<nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">Festival Bands</a>
    <div class="d-flex align-items-center gap-2 ms-auto">
      <a class="btn btn-outline-success btn-sm" routerLink="/login" *ngIf="!userEmail">Login</a>
      <!-- User menu dropdown -->
      <div *ngIf="userEmail" class="dropdown" #userMenuRef>
        <button type="button"
                class="btn btn-outline-secondary btn-sm"
                (click)="toggleUserMenu()"
                [attr.aria-expanded]="userMenuOpen"
                aria-haspopup="true"
                aria-label="Benutzermenü">
          <i class="bi bi-person-circle" style="font-size: 1.25rem;"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" [class.show]="userMenuOpen">
          <li><span class="dropdown-item-text small text-secondary">{{ userEmail }}</span></li>
          <li *ngIf="isAdmin"><a class="dropdown-item" routerLink="/admin" (click)="closeUserMenu()">Admin</a></li>
          <li><a class="dropdown-item" routerLink="/settings" (click)="closeUserMenu()">Einstellungen</a></li>
          <li><button class="dropdown-item text-danger" type="button" (click)="logout(); closeUserMenu()">Logout</button></li>
        </ul>
      </div>
    </div>
  </div>
</nav>

<div class="container mt-3">
  <router-outlet></router-outlet>
</div>

<!-- Floating theme toggle -->
<button class="theme-toggle" (click)="toggleTheme()" [attr.aria-label]="theme === 'light' ? 'Dark Mode aktivieren' : 'Light Mode aktivieren'" title="Theme wechseln">
  <span *ngIf="theme === 'light'" aria-hidden="true">🌙</span>
  <span *ngIf="theme === 'dark'" aria-hidden="true">☀️</span>
  <span class="visually-hidden">Theme Toggle</span>
  
</button>

<app-toasts></app-toasts>
